import Vue from 'vue';
import VueRouter from 'vue-router';
import RouteInitMiddleware from './middleware/RouteInitMiddleware';
import NProgress from 'nprogress';
import qs from './queryString.js'

Vue.use(VueRouter);

let routes = [];
let router;

let middlewareStore = [];
let afterEachClosures = [];

function buildRouter() {

    if (router instanceof VueRouter) {
        return router;
    }

    router = new VueRouter({
        mode: 'history',
        base: process.env.VUE_APP_BASE_URL || '/',
        routes,
        parseQuery: function(query) {
            return qs.parse(query);
        },
        stringifyQuery: function (query) {
            const queryString = qs.stringify(query);

            return queryString ? ('?' + queryString) : '';
        }
    });

    // Uruchomienie wszystkich warstw middleware
    router.beforeEach((to, from, next) => {

        // Middleware z pozycjami startowymi
        let middleware = [RouteInitMiddleware].concat(middlewareStore);

        if (to.meta.middleware) {
            if (Array.isArray(to.meta.middleware)) {
                middleware = middleware.concat(to.meta.middleware)
            } else {
                middleware.push(to.meta.middleware);
            }
        }

        let context = {
            from,
            next,
            router,
            to,
        };

        // Wyciąganie następnego middleware
        return middleware[0]({
            ...context,
            next: nextFactory(context, middleware, 1)
        });
    });


    router.afterEach((to, from) => {
        for (let closure of afterEachClosures) {
            closure({to, from});
        }
        NProgress.done();
    });


    return router;
}

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];

    // Jeśli nie ma żadnego następnego middleware to zwracany jest domyślny z vue route
    if (!subsequentMiddleware) return context.next;

    return () => {

        // Uruchamianie następnego middleware
        subsequentMiddleware({
            ...context,
            next: nextFactory(context, middleware, index + 1)
        });
    };
}

export default class RouterBuilder{

    static getRouter() {
        return buildRouter();
    }

    static addRawRoutes(newRoutes) {
        routes = routes.concat(newRoutes);
    }

    static addInitialMiddleware(middleware) {
        middlewareStore.push(middleware);
    }

    static addAfterEachClosure(closure) {
        afterEachClosures.push(closure);
    }
}
